import type { Product, Script } from "@easyshot/shared";
import { estimateInfiniteTalkDuration } from "./infinitetalk-flow";

/** Stored steps 0/1/2/3 are kept compatible with existing drafts. */
export function templateStepIndex(step: number): number {
  return step >= 3 ? 2 : step > 0 ? 1 : 0;
}
export function templateStoredStep(index: number): number {
  return index >= 2 ? 3 : index > 0 ? 1 : 0;
}
export function templateNeedsPerson(style: string, provider?: string): boolean {
  return !["motion", "faceless", "comment_ad", "pov_unboxing"].includes(style) && provider !== "minimax_h3";
}
export function productFromBrief(text: string, current?: Product | null): Product {
  const lines = text.trim().split(/\n+/).map(line => line.trim()).filter(Boolean);
  return {
    id: current?.id ?? `pd_${Date.now().toString(36)}`,
    title: lines[0]?.slice(0, 100) || "My product",
    description: text.trim(),
    sellingPoints: lines.slice(1),
    images: current?.images ?? [],
  };
}
/** Local script preparation never invokes a model or incurs a charge. */
export function templateScriptFromWords(text: string, styleName: string): Script {
  const narration = text.trim();
  const durationSec = estimateInfiniteTalkDuration(narration, Infinity);
  return {
    id: `sc_${Date.now().toString(36)}`,
    hook: "", cta: "",
    scenes: [{ id: `sn_${Date.now().toString(36)}`, narration, durationSec, visual: `${styleName}: show the supplied product materials faithfully.` }],
    totalDurationSec: durationSec,
    language: /[\p{Script=Han}]/u.test(narration) ? "zh-CN" : "en-US",
  };
}
